<template>
  <v-app>
    <!-- <AppHeader0 /> -->
    <!-- v-if="$route.name != 'login' && $route.name != 'signUp'" -->
    <AppHeader  />
    <!-- <AppHeader2
      v-if="
        $route.name == 'ecoShop'
      "
    /> -->
    <!-- <v-divider></v-divider> -->
    <router-view  style="background-color: #F6F9F7;" :key="$route.fullPath" v-bind:storage="sideNav" />
    <AppFooter/>
  </v-app>
</template>

<script>
import axios from "axios";
import AppHeader from "./components/Common/AppHeader";
// import AppHeader0 from "./components/Common/AppHeader0";
// import AppHeader2 from "./components/Common/AppHeader2";
import AppFooter from "./components/Common/AppFooter";
import "./assets/styles/fonts.css";
import "./assets/styles/appStyle.css";
export default {
  name: 'App',

  components: {
    AppHeader,
    // AppHeader0,
    // AppHeader2,
    AppFooter
  },
  computed: {
    appType() {
      // console.log(this.$store.state.userRole);
      return this.$store.state.userRole;
    },
    userId() {
      return this.localStorage.getItem("userId")
    },
    appUserId() {
      return this.localStorage.getItem("id")
    }
  },
  data: () => ({
    //
    sideNav: true,

  }),
  watch: {
    userId() {
      if (!this.userId)
      {
        this.getId()
      }
    }
  },
  beforeMount() {
    if (typeof localStorage.getItem("token")=='string') {this.getUser()}
    if (!localStorage.getItem("userId") && !localStorage.getItem("token"))
    {
      this.getId();
    }
    if(localStorage.getItem("userId") && !localStorage.getItem("token"))
    {
      this.getCount()
    }
  },
  methods: {
    winStepper(windowData) {
      this.sideNav = windowData.sideNav;
    },
    getUser() {
      axios({
        method: "get",
        url: "/user/profile/" + localStorage.getItem("id"),
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.$store.commit("userData", response.data.data);
            this.$store.commit("changeCart", response.data.cartCount);
            this.$store.commit("changeWishlist", response.data.wishListCount);
            // this.$store.commit("userType", response.data.data.user.role);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getId() {
      axios({
        method: "GET",
        url: "/user/guest/autoid",
      })
        .then((response) => {
          if (response.data.status) {
            localStorage.setItem("userId", response.data.guestId);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCount() {
      axios({
        method: "GET",
        url: "/user/guest/cartWishlistCount",
        params: {
          guestId: localStorage.getItem("userId"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.$store.commit("changeWishlist", response.data.wishListCount);
            this.$store.commit("changeCart", response.data.cartCount);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  }
};
</script>
